import React from "react";

export interface ProfileBannerProps {
  name: string;
  onBack: () => void;
}

export const ProfileBanner: React.FC<ProfileBannerProps> = ({ name, onBack }) => {
  return (
    <div className="relative w-full h-[220px] rounded-2xl overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-[url('/images/Dashboard/ProfileBannerBack.jpg')] bg-cover bg-center bg-no-repeat" />

      {/* Breadcrumb Text */}
      <div className="relative z-10 px-8 py-6">
        <p className="text-white/80 font-semibold text-xl">
          <button
            type="button"
            onClick={onBack}
            className="hover:text-white transition-colors"
          >
            Discovery
          </button>
          <span className="mx-1">/</span>
          <span className="text-white">{name}</span>
        </p>
      </div>
    </div>
  );
};

export default ProfileBanner;
